window.addEventListener('load', function() {
  const option = document.querySelector('.template-product-megnisium .cstmOptions[data-val="2 Month"]');
  
  if (option) {
    option.click();
  }
});
window.addEventListener('load', function() {
  const option = document.querySelector('.template-product-berbrine .cstmOptions[data-val="2 Month"]');
  
  if (option) {
    option.click();
  }
});
window.addEventListener('load', function() {
  const option = document.querySelector('.template-product-multivitamin .cstmOptions[data-val="Pack of 1"]');
  
  if (option) {
    option.click();
  }
});
window.addEventListener('load', function() {
  const option = document.querySelector('.template-product-multivitamin-women .cstmOptions[data-val="Pack of 1"]');
  
  if (option) {
    option.click();
  }
});
window.addEventListener('load', function () {
  const option = document.querySelector(
    '.template-product-metabolicallyeanswitch .switch-var-main[cstmvarint-id="47348806189281"]'
  );

  if (option) {
    option.click();
  }
});
window.onload = () => {
  if (!window.location.href.includes('metabolically-lean-weight-management')) { 
  const targetElement = document.querySelector(
    '.product__info-wrapper .cstmVariants input[value="2 Month"], .product__info-wrapper .cstmVariants input[value="2 Months"]'
  );
  if (targetElement) {
    // targetElement.click();
    // targetElement.closest('label')?.classList.add('selected'); 
  }
  }    
    if (window.location.href.includes('metabolically-lean-weight-management-ams')) {
    const submitButton = document.querySelector('.product__info-wrapper .product-form__submit');
    if (submitButton && submitButton.classList.contains('recurpay-hide')) {
      submitButton.classList.remove('recurpay-hide');
    }
          const targetOption = document.querySelector('.cstmOptions[cstmvarint-title="3 Month Subscription"]');
  if (targetOption) {
    console.log('targetOption',targetOption);
    targetOption.click();
  }
  } 
};

$(document).ready(function () {
  $("a[href^='#']").click(function (e) {
    e.preventDefault();

    var position = $($(this).attr("href")).offset().top;

    $("body, html").animate(
      {
        scrollTop: position,
      },
      500
    );
  });
});



$(document).ready(function () {
  $(".template-index .anachorTag-content").click(function () {
    $(".template-index .cstmTopBtn a").addClass("button-active");
  });
  $(".template-index .cstmTopBtn a").click(function () {
    $(this).removeClass("button-active");
  });
});

$(
  ".image-with-text__content--desktop-left .metafield-rich_text_field ul li"
).on("click", function () {
  $(this).toggleClass("active");
});
$(document).ready(function () {
  $(".cstmVariants").scrollLeft(-1000);
});

if (!$("body").hasClass("template-product-metlean-advance-boost")) {
  $(".cstmVariants").click(function () {
    $(".cstmVariants").scrollLeft(-1000);
    $("variant-radios").scrollLeft(-1000);
    console.log("scrolled");
  });
}
$(".template-product-metlean-advance-boost .cstmVariants").click(function () {
  if (
    $(this).find('[cstmvarint-title="3 Month"]').hasClass("selected") ||
    $(this).find('[cstmvarint-title="2 Month"]').hasClass("selected") ||
     $(this).find('[cstmvarint-title="3 Month Subscription"]').hasClass("selected") || 
    $(this).find('[cstmvarint-title="6 Month Subscription"]').hasClass("selected")
  ) {
    console.log(this);
    $(".template-product-metlean-advance-boost .cstmVariants").scrollLeft(1000);
    $(".variant-radios").scrollLeft(1000);
    console.log("scrolled");
  }
  if ($(this).find('[cstmvarint-title="1 Month"]').hasClass("selected")) {
    $(".template-product-metlean-advance-boost .cstmVariants").scrollLeft(
      -1000
    );
    $(".variant-radios").scrollLeft(-1000);
  }
  if ($(this).find('[cstmvarint-title="15 Days"]').hasClass("selected")) {
    $(".template-product-metlean-advance-boost .cstmVariants").scrollLeft(
      -1000
    );
    $(".variant-radios").scrollLeft(-1000);
  }
});
// var cartVar = document.querySelectorAll('.cstmOptions');
// var cstmVr = document.querySelectorAll('.variant-under');

// document.addEventListener("DOMContentLoaded", function() {
//     cartVar.forEach(function(element) {
//        element.addEventListener('click', function() {
//          alert('hi',cstmVr); // ensure 'alert' is spelled correctly
//        });
//     });
// });

//Open Buy Now in collection
var variants = document.querySelectorAll(".buy_variants");
var cartBtns = document.querySelectorAll(".cart_btn");
var closeHeads = document.querySelectorAll(".buy_variants_head");

variants.forEach(function (variant) {
  variant.style.display = "none";
});
cartBtns.forEach(function (cartBtn, index) {
  cartBtn.addEventListener("click", function () {
    // Hide all variants
    variants.forEach(function (variant) {
      variant.style.display = "none";
    });
    var variant = variants[index];
    variant.style.display = "block";
    variant.classList.add("active-buy-button");
  });
});

closeHeads.forEach(function (closeHead, index) {
  closeHead.addEventListener("click", function () {
    var variant = variants[index];
    variant.style.display = "none";
    variant.classList.remove("active-buy-button");
  });
});

//Open Click on BUY NOW in collection
var miniCart = document.querySelector("cart-drawer");
let next_btn = document.querySelectorAll(".cart_next_btn");
next_btn?.forEach((item) => {
  item.addEventListener("click", () => {
    let att = item.getAttribute("prd-id");
    let data = [];
    data.push({
      id: att,
      quantity: 1,
    });
    let formData = {
      items: data,
      sections: miniCart.getSectionsToRender().map((section) => section.id),
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((resp) => {
        miniCart.renderContents(resp);
        miniCart.classList.remove("is-empty");
      })
      .catch((error) => {
        console.log("ERROR :", error);
      });
  });
});
//Close Click BUY NOW on collection
document.body.addEventListener("click", (e) => {
  let target = e.target;
  target = target?.closest(
    ".buy_variants.active-buy-button .buy_variants_cart"
  );
  if (target) {
    let att = target.getAttribute("data-first-variant");
    let data = [];
    data.push({
      id: att,
      quantity: 1,
    });
    let formData = {
      items: data,
      sections: miniCart.getSectionsToRender().map((section) => section.id),
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((resp) => {
        miniCart.renderContents(resp);
        miniCart.classList.remove("is-empty");
      })
      .catch((error) => {
        console.log("ERROR :", error);
      });
  }
});
// new-variant-select
window.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll("custom-variant-selector");
  products.forEach((product) => {
    const variantSpans = product.querySelectorAll(".new_var_select");
    variantSpans.forEach(function (span) {
      span.addEventListener("click", function (event) {
        event.preventDefault();
        variantSpans.forEach(function (s) {
          s.classList.remove("active");
        });
        span.classList.add("active");
        const variantId = span.getAttribute("variant-new-attr");
        const variantQty = span.getAttribute("inv-var");
        const variantPrice = span.getAttribute("variant-price-attr");
        const priceNumber = parseFloat(variantPrice.replace(/[^0-9.-]/g, ""));
        const result = priceNumber / 100;
        const variantComPrice = span.getAttribute("variant-comp-price-attr");
        const priceComNumber = parseFloat(
          variantComPrice.replace(/[^0-9.-]/g, "")
        );
        const resultCom = priceComNumber / 100;
        const altText = span.getAttribute("variant-image");
        let cardWrapper = span.closest(".card-wrapper");
        if (cardWrapper) {
          let quickAddSubmit = cardWrapper.querySelector(".quick-add__submit");
          if (quickAddSubmit) {
            let inputId = cardWrapper.querySelector('input[name="id"]');
            if (inputId) {
              inputId.value = variantId;
            }
            const quickReAdd = quickAddSubmit.querySelector("span");
            if (!span.classList.contains("lemon-grass-sold")) {
              if (quickReAdd) {
                quickReAdd.textContent = "Add to cart";
              }
              quickAddSubmit.removeAttribute("disabled");
            } else if (variantQty < 1) {
              if (quickReAdd) {
                quickReAdd.textContent = "Sold out";
              }
              quickAddSubmit.setAttribute("disabled", true);
            }
          }
          let quickAddPrice = cardWrapper.querySelector(".price__sale");
          if (quickAddPrice) {
            let price = cardWrapper.querySelector(".price-item--sale");
            if (price) {
              price.textContent = "₹" + result;
            }
            let Comprice = cardWrapper.querySelector(".compare--cssm--new");
            console.log("Comprice>>>", Comprice);
            if (Comprice && !isNaN(resultCom)) {
              Comprice.textContent = "₹" + resultCom;
              Comprice.classList.add("compare--cssm--newss");
            }
          }
          let quickAddPriceNew = cardWrapper.querySelector(".price__regular");
          if (quickAddPriceNew) {
            let priceNeu = cardWrapper.querySelector(".price-item--regular");
            if (priceNeu) {
              priceNeu.textContent = "₹" + result;
            }
          }
          let changeSrc = cardWrapper.querySelector(".media");
          console.log("changeSrc>>>", changeSrc);
          if (changeSrc) {
            let variantSc = cardWrapper.querySelector("img[srcset]");
            if (variantSc) {
              if (altText && altText != "") {
                variantSc.setAttribute("srcset", altText);
              }
            }
          }
        }
      });
    });
  });
});

// Addition info
$(document).ready(function () {
  const elements = document.querySelectorAll("[data-variant-show]");
  if (elements.length >= 2 && !window.location.href.includes('metabolically-lean-weight-management')) {
    elements[2].classList.add("additional-net-qty-active");
  } 
  if (elements.length >= 2 && window.location.href.includes('metabolically-lean-weight-management')) {
    elements[0].classList.add("additional-net-qty-active");
  } 
});
$(document).on("click", ".cstmOptions", function () {
  const elements = document.querySelectorAll("[data-variant-show]");
  var cstmvrID = $(this).attr("cstmvarint-id");
    const activeInner = $(this).find(".variantInner:not(.d-none)");
  const cstmvrIDMb = activeInner.attr("data-selt-addition");
  console.log('cstmvrIDMb',cstmvrIDMb);
  console.log("Custom Variant ID nnew:", cstmvrID);
  elements.forEach((element) => {
    element.classList.remove("additional-net-qty-active");
  });
  elements.forEach((element) => {
    const dataVariantShow = element.getAttribute("data-variant-show");
    const dataVariantShowMb = element.getAttribute("data-title");
    if (window.location.href.includes('metabolically-lean-weight-management')) {
         if (dataVariantShowMb === cstmvrIDMb) {
      element.classList.add("additional-net-qty-active");
    }
    } else {
    if (dataVariantShow === cstmvrID) {
      element.classList.add("additional-net-qty-active");
    }
  } 
  });
});
$(document).on("click", ".variant-box-int", function () {
  const elements = document.querySelectorAll("[data-variant-show]");
  var cstmvrID = $(this).attr("data-id");
  console.log("Custom Variant ID nnew:", cstmvrID);
  elements.forEach((element) => {
    element.classList.remove("active");
  });
  elements.forEach((element) => {
    const dataVariantShow = element.getAttribute("data-variant-show");
    if (dataVariantShow === cstmvrID) {
      element.classList.add("active");
    }
  });
});
$(document).on("click", ".variant-box-int-kambucha", function () {
  const elements = document.querySelectorAll("[data-variant-show]");
  var cstmvrID = $(this).attr("data-v-id");
  console.log("Custom Variant ID nnew:", cstmvrID);
  elements.forEach((element) => {
    element.classList.remove("active");
  });
  elements.forEach((element) => {
    const dataVariantShow = element.getAttribute("data-variant-show");
    if (dataVariantShow === cstmvrID) {
      element.classList.add("active");
    }
  });
});

document.querySelectorAll(".accordion-header").forEach((header) => {
  header.addEventListener("click", function () {
    const content = this.nextElementSibling;
    if (!content) return;
    const iconPlus = this.querySelector(".icon-plus");
    const iconMinus = this.querySelector(".icon-minus");
    document.querySelectorAll(".accordion-content").forEach((section) => {
      const item = section.closest(".accordion-item");
      if (item && !item.isSameNode(header.closest(".accordion-item"))) {
        section.classList.remove("active");
        const otherHeader = item.querySelector(".accordion-header");
        if (otherHeader) {
          otherHeader.querySelector(".icon-plus").classList.remove("d-none");
          otherHeader.querySelector(".icon-minus").classList.add("d-none");
        }
      }
    });
    content.classList.toggle("active");
    iconPlus.classList.toggle("d-none");
    iconMinus.classList.toggle("d-none");
  });
});

const callUsExpertNumbers = document.querySelectorAll(".callusexpert-number");
const typeFromXSpeakToExperts = document.querySelectorAll(
  ".typefromx-speaktoexpert"
);
const liveElements = document.querySelectorAll(".start-slow-body");

function toggleVisibility() {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const startHour = 10;
  const startMinute = 00;
  const endHour = 18;
  const endMinute = 30;

  const isWithinTime =
    (currentHour > startHour ||
      (currentHour === startHour && currentMinute >= startMinute)) &&
    (currentHour < endHour ||
      (currentHour === endHour && currentMinute <= endMinute));

  if (callUsExpertNumbers.length > 0) {
    callUsExpertNumbers.forEach((element) => {
      element.classList.toggle("active", isWithinTime);
    });
  }

  if (typeFromXSpeakToExperts.length > 0) {
    typeFromXSpeakToExperts.forEach((element) => {
      element.classList.toggle("active", !isWithinTime);
    });
  }

  if (liveElements.length > 0) {
    liveElements.forEach((element) => {
      element.classList.toggle("active", isWithinTime);
    });
  }
}

toggleVisibility();
setInterval(toggleVisibility, 60000);

// const callUsExpertNumbers = document.querySelectorAll(".callusexpert-number");
// const typeFromXSpeakToExperts = document.querySelectorAll(".typefromx-speaktoexpert");
// const liveElements = document.querySelectorAll(".start-slow-body");

// function toggleVisibility() {
//   if (callUsExpertNumbers.length > 0) {
//     callUsExpertNumbers.forEach((element) => {
//       element.classList.remove("active");
//     });
//   }

//   if (typeFromXSpeakToExperts.length > 0) {
//     typeFromXSpeakToExperts.forEach((element) => {
//       element.classList.add("active");
//     });
//   }

//   const now = new Date();
//   const currentHour = now.getHours();
//   const currentMinute = now.getMinutes();
//   const startHour = 10;
//   const startMinute = 0;
//   const endHour = 18;
//   const endMinute = 30;

//   const isWithinTime =
//     (currentHour > startHour ||
//       (currentHour === startHour && currentMinute >= startMinute)) &&
//     (currentHour < endHour ||
//       (currentHour === endHour && currentMinute <= endMinute));

//   if (liveElements.length > 0) {
//     liveElements.forEach((element) => {
//       element.classList.toggle("active", isWithinTime);
//     });
//   }
// }

// toggleVisibility();
// setInterval(toggleVisibility, 60000);

function setBenefitImgHeight() {
  const features = document.querySelector('.custom-product-features');
  const img = document.querySelector('.desktop-benifitimg');

  if (features && img) {
    img.style.height = (features.offsetHeight - 100) + 'px';
  }
}

document.addEventListener('DOMContentLoaded', setBenefitImgHeight);
window.addEventListener('resize', setBenefitImgHeight);

const features = document.querySelector('.custom-product-features');
const img = document.querySelector('.desktop-benifitimg');

if (features && img) {
  const updateHeight = () => {
    img.style.height = (features.offsetHeight - 100) + 'px';
  };

  updateHeight();

  new ResizeObserver(updateHeight).observe(features);
}

function updateBenefitHeight() {
  const features = document.querySelector('.custom-product-features');
  const img = document.querySelector('.desktop-benifitimg');

  if (!features || !img) return;

  const width = window.innerWidth;
  const minusHeight = (width >= 1149 && width <= 1299) ? 290 : 80;

  img.style.height =
    Math.max(features.getBoundingClientRect().height - minusHeight, 0) + 'px';
}

document.addEventListener('DOMContentLoaded', () => {
  updateBenefitHeight();

  const features = document.querySelector('.custom-product-features');

  if (features) {
    new ResizeObserver(updateBenefitHeight).observe(features);
  }

  window.addEventListener('resize', updateBenefitHeight);
  window.visualViewport?.addEventListener('resize', updateBenefitHeight);
});

document.addEventListener('DOMContentLoaded', () => {
  updateBenefitHeight();

  const features = document.querySelector('.custom-product-features');

  if (features) {
    new ResizeObserver(updateBenefitHeight).observe(features);
  }

  window.addEventListener('resize', updateBenefitHeight);

  // Browser zoom detect
  window.visualViewport?.addEventListener('resize', updateBenefitHeight);
});